import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import Layout from "../components/Layout.jsx";
import KPISection from "./components/KPISection.jsx";
import MetricsCards from "./components/MetricsCards.jsx";
import HolidayCalendarButton from "../components/HolidayCalendarButton.jsx";

import {
  kpiService,
  employeeService,
  utilService,
  dashboardService,
  announcementService,
} from "../services/apiService.jsx";
import "./Dashboard.css";

const getAnnouncementCategoryLabel = (category) =>
  (category || "general")
    .replaceAll("_", " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

const Dashboard = () => {
  const { user } = useAuth();
  // State Management // [EDITED: KPI Task - Mahesh Sharma]
  const [kpiWeek, setKpiWeek] = useState(""); // [EDITED: KPI Task - Mahesh Sharma]
  const [ratingWeek, setRatingWeek] = useState(""); // [EDITED: KPI Task - Mahesh Sharma]
  const [kpiNotSubmitted, setKpiNotSubmitted] = useState([]); // [EDITED: KPI Task - Mahesh Sharma]
  const [kpiSubmitted, setKpiSubmitted] = useState([]); // [EDITED: KPI Task - Mahesh Sharma]
  const [submissionTab, setSubmissionTab] = useState("not_submitted"); // [EDITED: KPI Task - Mahesh Sharma]
  const [kpiNotRated, setKpiNotRated] = useState([]); // [EDITED: KPI Task - Mahesh Sharma]
  const [kpiRated, setKpiRated] = useState([]); // [EDITED: KPI Task - Mahesh Sharma]
  const [ratingTab, setRatingTab] = useState("not_rated"); // [EDITED: KPI Task - Mahesh Sharma]
  const [kpiLoading, setKpiLoading] = useState(false); // [EDITED: KPI Task - Mahesh Sharma]
  const [ratingLoading, setRatingLoading] = useState(false); // [EDITED: KPI Task - Mahesh Sharma]
  const [currentDateTime, setCurrentDateTime] = useState(new Date()); // [EDITED: KPI Task - Mahesh Sharma]
  const [metrics, setMetrics] = useState({ // [EDITED: KPI Task - Mahesh Sharma]
    employeeTotal: 0, // [EDITED: KPI Task - Mahesh Sharma]
    clientTotal: 0, // [EDITED: KPI Task - Mahesh Sharma]
    projectTotal: 0, // [EDITED: KPI Task - Mahesh Sharma]
  }); // [EDITED: KPI Task - Mahesh Sharma]
  const [birthdays, setBirthdays] = useState([]); // [EDITED: KPI Task - Mahesh Sharma]
  const [workAnniversaries, setWorkAnniversaries] = useState([]); // [EDITED: KPI Task - Mahesh Sharma]
  const [employeeOfMonth, setEmployeeOfMonth] = useState(null); // [EDITED: KPI Task - Mahesh Sharma]
  const [announcements, setAnnouncements] = useState([]);
  const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
  const [announcementEmployees, setAnnouncementEmployees] = useState([]);
  const [announcementSaving, setAnnouncementSaving] = useState(false);
  const [announcementNotice, setAnnouncementNotice] = useState("");
  const [editingAnnouncementId, setEditingAnnouncementId] = useState(null);
  const [announcementForm, setAnnouncementForm] = useState({
    category: "employee_of_year",
    title: "",
    message: "",
    employee_id: "",
    announcement_date: new Date().toISOString().slice(0, 10),
    is_active: true,
    announcement_photo: null,
  });
  const [dashboardLoading, setDashboardLoading] = useState(false); // [EDITED: KPI Task - Mahesh Sharma]

  // Carousel state
  const [birthdayIndex, setBirthdayIndex] = useState(0);
  const [workAnniversaryIndex, setWorkAnniversaryIndex] = useState(0);

  // Modal state for employee list (management dashboard)
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [selectedReviewer, setSelectedReviewer] = useState(null);

  useEffect(() => {
    const defaultWeek = getPreviousWeek();
    setKpiWeek(defaultWeek);
    setRatingWeek(defaultWeek);

    // Load all dashboard data from the role-dashboard endpoint
    loadDashboardData();

    // Update date/time every minute
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  // Auto-load KPI data when week changes // [EDITED: KPI Task - Mahesh Sharma]
  useEffect(() => { // [EDITED: KPI Task - Mahesh Sharma]
    if (kpiWeek) { // [EDITED: KPI Task - Mahesh Sharma]
      loadKpiSubmissions(); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
  }, [kpiWeek]); // [EDITED: KPI Task - Mahesh Sharma]

  useEffect(() => { // [EDITED: KPI Task - Mahesh Sharma]
    if (ratingWeek) { // [EDITED: KPI Task - Mahesh Sharma]
      loadKpiRatings(); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
  }, [ratingWeek]); // [EDITED: KPI Task - Mahesh Sharma]

  // Carousel auto-rotation
  useEffect(() => {
    if (birthdays.length > 1) {
      const birthdayTimer = setInterval(() => {
        setBirthdayIndex((prev) => (prev + 1) % birthdays.length);
      }, 5000);
      return () => clearInterval(birthdayTimer);
    }
  }, [birthdays]);

  useEffect(() => {
    if (workAnniversaries.length > 1) {
      const workTimer = setInterval(() => {
        setWorkAnniversaryIndex(
          (prev) => (prev + 1) % workAnniversaries.length,
        );
      }, 5000);
      return () => clearInterval(workTimer);
    }
  }, [workAnniversaries]);

  const loadDashboardData = async () => {
    setDashboardLoading(true);
    try {
      const response = await dashboardService.getRoleDashboard();

      if (response && response.success && response.data) {
        const {
          total_employees,
          team_members,
          department_employees,
          total_clients,
          total_projects,
        } = response.data;

        setMetrics({
          employeeTotal: total_employees ?? team_members ?? department_employees ?? 0,
          clientTotal: total_clients || 0,
          projectTotal: total_projects || 0,
        });

        loadBirthdaysAndAnniversaries();
      } else {
        console.warn(
          "Role dashboard endpoint failed, falling back to individual calls",
        );
        loadMetrics();
        loadBirthdaysAndAnniversaries();
      }
    } catch (error) {
      console.error("Error loading dashboard data:", error);
      loadMetrics();
      loadBirthdaysAndAnniversaries();
    } finally {
      setDashboardLoading(false);
    }
  };

  const loadBirthdaysAndAnniversaries = async () => {
    try {
      // Get current month (1-12)
      const currentMonth = new Date().getMonth() + 1;

      const results = await Promise.allSettled([
        utilService.getUpcomingBirthdays(),
        utilService.getEmployeeOfTheMonth(),
        utilService.getUpcomingAnniversariesByMonth(currentMonth),
        announcementService.getPublished(),
      ]);

      const [birthdaysResult, employeeOfMonthResult, workAnniversariesResult, announcementsResult] = results;
      const birthdaysRes = birthdaysResult.status === "fulfilled" ? birthdaysResult.value : null;
      const employeeOfMonthRes = employeeOfMonthResult.status === "fulfilled" ? employeeOfMonthResult.value : null;
      const workAnniversariesRes = workAnniversariesResult.status === "fulfilled" ? workAnniversariesResult.value : null;
      const announcementsRes = announcementsResult.status === "fulfilled" ? announcementsResult.value : null;

      results.forEach((result, index) => {
        if (result.status === "rejected") {
          console.error(`Dashboard announcement card request ${index + 1} failed:`, result.reason);
        }
      });

      const announcementsData = announcementsRes?.data?.data || announcementsRes?.data || [];
      setAnnouncements(Array.isArray(announcementsData) ? announcementsData : []);

      // Handle birthdays data - check different possible paths
      let birthdaysData = [];

      // Try different response structures
      if (birthdaysRes?.data?.data && Array.isArray(birthdaysRes.data.data)) {
        birthdaysData = birthdaysRes.data.data;
      } else if (birthdaysRes?.data && Array.isArray(birthdaysRes.data)) {
        birthdaysData = birthdaysRes.data;
      } else if (Array.isArray(birthdaysRes)) {
        birthdaysData = birthdaysRes;
      }

      // Map the data to the format we need
      const mappedBirthdays = birthdaysData.map((emp) => ({
        employee_id: emp.employee_id,
        name: `${emp.first_name || ""} ${emp.last_name || ""}`.trim(),
        department: emp.department_name || "",
        days_until: emp.days_until_birthday || 0,
        profile_photo: emp.profile_photo || null,
      }));

      setBirthdays(mappedBirthdays);

      // Handle work anniversaries data
      let workAnniversariesData = [];

      // Try different response structures
      if (
        workAnniversariesRes?.data?.data &&
        Array.isArray(workAnniversariesRes.data.data)
      ) {
        workAnniversariesData = workAnniversariesRes.data.data;
      } else if (
        workAnniversariesRes?.data &&
        Array.isArray(workAnniversariesRes.data)
      ) {
        workAnniversariesData = workAnniversariesRes.data;
      } else if (Array.isArray(workAnniversariesRes)) {
        workAnniversariesData = workAnniversariesRes;
      }

      // Map the data to the format we need
      const mappedWorkAnniversaries = workAnniversariesData
        .map((emp) => ({
          employee_id: emp.employee_id,
          name: `${emp.first_name || ""} ${emp.last_name || ""}`.trim(),
          department: emp.department_name || "",
          years: emp.years || emp.years_of_service || 0,
          joining_date: emp.joining_date || emp.Joiningdate || "",
          profile_photo: emp.profile_photo || null,
        }))
        .filter((emp) => emp.years >= 1);

      setWorkAnniversaries(mappedWorkAnniversaries);

      // Handle employee of the month data
      let employeeOfMonthData = null;

      // Try different response structures
      if (employeeOfMonthRes?.data?.data) {
        employeeOfMonthData = employeeOfMonthRes.data.data;
      } else if (employeeOfMonthRes?.data) {
        employeeOfMonthData = employeeOfMonthRes.data;
      } else if (employeeOfMonthRes) {
        employeeOfMonthData = employeeOfMonthRes;
      }

      if (employeeOfMonthData) {
        const mappedEmployee = {
          employee_id: employeeOfMonthData.employee_id,
          name: `${employeeOfMonthData.first_name || ""} ${employeeOfMonthData.last_name || ""}`.trim(),
          department: employeeOfMonthData.department_name || "",
          total_hours: employeeOfMonthData.total_hours || 0,
          total_tasks: employeeOfMonthData.total_tasks || 0,
          profile_photo: employeeOfMonthData.profile_photo || null,
          message: employeeOfMonthData.latest_description || "",
        };
        setEmployeeOfMonth(mappedEmployee);
      } else {
        setEmployeeOfMonth(null);
      }
    } catch (error) {
      console.error("Error loading birthdays and anniversaries:", error);
    }
  };

  // [EDITED: KPI Task - Mahesh Sharma]
  const loadKpiSubmissions = async () => { // [EDITED: KPI Task - Mahesh Sharma]
    if (!kpiWeek) return; // [EDITED: KPI Task - Mahesh Sharma]

    setKpiLoading(true); // [EDITED: KPI Task - Mahesh Sharma]
    try { // [EDITED: KPI Task - Mahesh Sharma]
      const response = await kpiService.getSubmissionsStatus(kpiWeek); // [EDITED: KPI Task - Mahesh Sharma]
      const data = response?.data || response || {}; // [EDITED: KPI Task - Mahesh Sharma]
      
      setKpiNotSubmitted(data.notSubmitted || []); // [EDITED: KPI Task - Mahesh Sharma]
      setKpiSubmitted(data.submitted || []); // [EDITED: KPI Task - Mahesh Sharma]
    } catch (error) { // [EDITED: KPI Task - Mahesh Sharma]
      console.error("Error fetching KPI submissions status:", error); // [EDITED: KPI Task - Mahesh Sharma]
    } finally { // [EDITED: KPI Task - Mahesh Sharma]
      setKpiLoading(false); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  const loadKpiRatings = async () => { // [EDITED: KPI Task - Mahesh Sharma]
    if (!ratingWeek) return; // [EDITED: KPI Task - Mahesh Sharma]

    setRatingLoading(true); // [EDITED: KPI Task - Mahesh Sharma]
    try { // [EDITED: KPI Task - Mahesh Sharma]
      const response = await kpiService.getRatingsStatus(ratingWeek); // [EDITED: KPI Task - Mahesh Sharma]
      const data = response?.data || response || {}; // [EDITED: KPI Task - Mahesh Sharma]
      
      setKpiNotRated(data.notRated || []); // [EDITED: KPI Task - Mahesh Sharma]
      setKpiRated(data.rated || []); // [EDITED: KPI Task - Mahesh Sharma]
    } catch (error) { // [EDITED: KPI Task - Mahesh Sharma]
      console.error("Error fetching KPI ratings status:", error); // [EDITED: KPI Task - Mahesh Sharma]
    } finally { // [EDITED: KPI Task - Mahesh Sharma]
      setRatingLoading(false); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  const handleRevokeRating = async (kpiId) => { // [EDITED: KPI Task - Mahesh Sharma]
    if (!window.confirm("Are you sure you want to revoke this rating? The submission will be reopened for re-evaluation.")) { // [EDITED: KPI Task - Mahesh Sharma]
      return; // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
    try { // [EDITED: KPI Task - Mahesh Sharma]
      await kpiService.revokeKPIRating(kpiId); // [EDITED: KPI Task - Mahesh Sharma]
      alert("Rating revoked successfully! The KPI is now pending evaluation."); // [EDITED: KPI Task - Mahesh Sharma]
      loadKpiRatings(); // [EDITED: KPI Task - Mahesh Sharma]
      loadKpiSubmissions(); // [EDITED: KPI Task - Mahesh Sharma]
    } catch (error) { // [EDITED: KPI Task - Mahesh Sharma]
      console.error("Error revoking rating:", error); // [EDITED: KPI Task - Mahesh Sharma]
      alert(error.response?.data?.message || "Failed to revoke rating"); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  const getWeekNumber = (date) => {
    const d = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
    );
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  };

  // Dashboard should open on last week's KPI data by default, not the
  // still-in-progress current week.
  const getPreviousWeek = () => {
    const lastWeekDate = new Date();
    lastWeekDate.setDate(lastWeekDate.getDate() - 7);
    const year = lastWeekDate.getFullYear();
    const weekNum = getWeekNumber(lastWeekDate);
    return `${year}-W${weekNum.toString().padStart(2, "0")}`;
  };

  const loadMetrics = async () => {
    try {
      const role = String(user?.role || "").toLowerCase().trim();
      const employeesRequest = role === "hod" || role.includes("head")
        ? employeeService.getHodReportingEmployees()
        : role === "team lead" || role === "teamleader" || role === "tl" || role.includes("lead")
          ? employeeService.getReportingEmployees()
          : employeeService.getAllEmployees();
      const [empRes, clientRes, projectRes] = await Promise.all([
        employeesRequest,
        employeeService.getAllClients
          ? employeeService.getAllClients()
          : Promise.resolve({ data: [] }),
        employeeService.getAllProjects
          ? employeeService.getAllProjects()
          : Promise.resolve({ data: [] }),
      ]);

      setMetrics({
        employeeTotal: empRes?.data?.length || empRes?.length || 0,
        clientTotal: clientRes?.data?.length || clientRes?.length || 0,
        projectTotal: projectRes?.data?.length || projectRes?.length || 0,
      });
    } catch (error) {
      console.error("Error loading metrics:", error);
    }
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatDateTime = (date) => {
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  // Helper function to format joining date
  const formatJoiningDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  // Check if user is an employee (not management)
  const isEmployee = () => {
    const employeeRoles = ["employee", "staff", "user"];
    return employeeRoles.includes(user?.role?.toLowerCase());
  };

  // Check if user has management role (admin, hod, team lead)
  const isManagement = () => {
    const managementRoles = [
      "admin",
      "super_admin",
      "hod",
      "team lead",
      "manager",
    ];
    return managementRoles.includes(user?.role?.toLowerCase());
  };

  // Check if user is admin (see all employees)
  const isAdmin = () => {
    const adminRoles = ["admin", "super_admin"];
    return adminRoles.includes(user?.role?.toLowerCase());
  };

  // Handle row click in KPI Not Rated table
  const handleReviewerRowClick = (reviewer) => {
    setSelectedReviewer(reviewer);
    setShowEmployeeModal(true);
  };

  const openAnnouncementModal = async (announcement = null) => {
    setShowAnnouncementModal(true);
    setAnnouncementNotice("");
    setEditingAnnouncementId(announcement?.id || null);
    if (announcement) {
      setAnnouncementForm({
        category: announcement.category || "general",
        title: announcement.title || "",
        message: announcement.message || "",
        employee_id: announcement.employee_id || "",
        announcement_date: announcement.announcement_date?.slice(0, 10) || new Date().toISOString().slice(0, 10),
        is_active: announcement.is_active !== 0,
        announcement_photo: null,
      });
    } else {
      setAnnouncementForm({
        category: "employee_of_year",
        title: "",
        message: "",
        employee_id: "",
        announcement_date: new Date().toISOString().slice(0, 10),
        is_active: true,
        announcement_photo: null,
      });
    }
    try {
      const response = await employeeService.getAllEmployees();
      const employees = response?.data?.data || response?.data || response || [];
      setAnnouncementEmployees(Array.isArray(employees) ? employees : []);
    } catch (error) {
      setAnnouncementNotice("Could not load employees");
    }
  };

  const handleAnnouncementChange = (event) => {
    const { name, value, type, checked, files } = event.target;
    setAnnouncementForm((current) => ({
      ...current,
      [name]: type === "checkbox" ? checked : type === "file" ? files[0] : value,
    }));
  };

  const handleAnnouncementSubmit = async (event) => {
    event.preventDefault();
    setAnnouncementSaving(true);
    setAnnouncementNotice("");
    try {
      const formData = new FormData();
      Object.entries(announcementForm).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          formData.append(key, value);
        }
      });
      if (editingAnnouncementId) {
        await announcementService.update(editingAnnouncementId, formData);
      } else {
        await announcementService.create(formData);
      }
      setAnnouncementForm((current) => ({
        ...current,
        title: "",
        message: "",
        employee_id: "",
        announcement_photo: null,
      }));
      await loadBirthdaysAndAnniversaries();
      setAnnouncementNotice("Announcement published successfully.");
      setEditingAnnouncementId(null);
    } catch (error) {
      setAnnouncementNotice(error.response?.data?.message || "Could not publish announcement");
    } finally {
      setAnnouncementSaving(false);
    }
  };

  if (dashboardLoading) {
    return (
      <Layout>
        <main className="dashboard__main">
          <div className="dashboard__loading">
            <div className="spinner"></div>
            <p>Loading your dashboard...</p>
          </div>
        </main>
      </Layout>
    );
  }

  return (
    <Layout>
      <main className="dashboard__main">
        {/* Employee Welcome Section - ONLY visible to employees */}
        {isEmployee() && (
          <>
            <div className="dashboard__welcome-section">
              <div className="dashboard__welcome-content">
                {/* Left side - Text content */}
                <div className="dashboard__welcome-text">
                  <h2 className="dashboard__welcome-title">Dashboard</h2>
                  <p className="dashboard__welcome-subtitle">
                    Welcome to BuildINT Tracking System
                  </p>

                  {/* Thought bubble */}
                  <div className="dashboard__thought-bubble">
                    <p className="dashboard__thought-text">
                      "You can't improve what you don't measure."
                    </p>
                    <p className="dashboard__thought-author">— Peter Drucker</p>
                  </div>

                  {/* User greeting with timestamp */}
                  <div className="dashboard__user-greeting">
                    <span className="dashboard__greeting-text">
                      Hi! {user?.first_name?.toLowerCase() || "user"}, Welcome to
                      BTS
                    </span>
                    <span className="dashboard__greeting-separator">·</span>
                    <span className="dashboard__greeting-time">
                      {formatDateTime(currentDateTime)}
                    </span>
                    <HolidayCalendarButton />
                  </div>
                </div>

                {/* Right side - GIF */}
                <div className="dashboard__welcome-gif">
                  <img
                    src="/assets/img/gif_1.gif"
                    alt="Welcome animation"
                    className="dashboard__welcome-gif-img"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.style.display = "none";
                    }}
                  />
                </div>
              </div>
            </div>

          </>
        )}

        {/* Management Dashboard - Header and Metrics */}
        {isManagement() && (
          <>
            {/* Modern Dashboard Header */}
            <div className="dashboard__header">
              <div className="dashboard__header-left">
                <h1 className="dashboard__greeting">
                  {getGreeting()},{" "}
                  <span className="dashboard__greeting-name">
                    {user?.first_name || "User"}
                  </span>
                </h1>
              </div>
              <div className="dashboard__header-right">
                <HolidayCalendarButton />
                <div className="dashboard__date-badge">
                  <span className="dashboard__date-text">
                    {formatDate(currentDateTime)}
                  </span>
                </div>
              </div>
            </div>

            {/* Metrics Cards - Top Row */}
            <MetricsCards metrics={metrics} />
          </>
        )}

        {/* KPI Sections Side by Side with Sub-Tabs (Submitted/Not Submitted & Rated/Not Rated) - VISIBLE TO ALL ROLES */}
        <div className="dashboard__kpi-row"> {/* [EDITED: KPI Task - Mahesh Sharma] */}
          {/* KPI Submissions (Not Submitted / Submitted) */}
          <KPISection
            title="KPI Submissions" // [EDITED: KPI Task - Mahesh Sharma]
            week={kpiWeek} // [EDITED: KPI Task - Mahesh Sharma]
            onWeekChange={setKpiWeek} // [EDITED: KPI Task - Mahesh Sharma]
            tabs={[ // [EDITED: KPI Task - Mahesh Sharma]
              { id: "not_submitted", label: "Not Submitted", count: kpiNotSubmitted.length }, // [EDITED: KPI Task - Mahesh Sharma]
              { id: "submitted", label: "Submitted", count: kpiSubmitted.length } // [EDITED: KPI Task - Mahesh Sharma]
            ]} // [EDITED: KPI Task - Mahesh Sharma]
            activeTab={submissionTab} // [EDITED: KPI Task - Mahesh Sharma]
            onTabChange={setSubmissionTab} // [EDITED: KPI Task - Mahesh Sharma]
            data={submissionTab === "not_submitted" ? kpiNotSubmitted : kpiSubmitted} // [EDITED: KPI Task - Mahesh Sharma]
            loading={kpiLoading} // [EDITED: KPI Task - Mahesh Sharma]
            columns={ // [EDITED: KPI Task - Mahesh Sharma]
              submissionTab === "not_submitted" // [EDITED: KPI Task - Mahesh Sharma]
                ? ["Employee Code", "Employee Name", "Department", "Role"] // [EDITED: KPI Task - Mahesh Sharma]
                : ["Employee Code", "Employee Name", "Department", "Self Points", "Status"] // [EDITED: KPI Task - Mahesh Sharma]
            } // [EDITED: KPI Task - Mahesh Sharma]
            dataKeys={ // [EDITED: KPI Task - Mahesh Sharma]
              submissionTab === "not_submitted" // [EDITED: KPI Task - Mahesh Sharma]
                ? ["employee_code", "employee_name", "department_name", "role"] // [EDITED: KPI Task - Mahesh Sharma]
                : ["employee_code", "employee_name", "department_name", "selfPoints", "submission_status"] // [EDITED: KPI Task - Mahesh Sharma]
            } // [EDITED: KPI Task - Mahesh Sharma]
            showExport={false} // [EDITED: KPI Task - Mahesh Sharma]
          />

          {/* KPI Ratings (Not Rated / Rated) */}
          <KPISection
            title="KPI Ratings" // [EDITED: KPI Task - Mahesh Sharma]
            week={ratingWeek} // [EDITED: KPI Task - Mahesh Sharma]
            onWeekChange={setRatingWeek} // [EDITED: KPI Task - Mahesh Sharma]
            tabs={[ // [EDITED: KPI Task - Mahesh Sharma]
              { id: "not_rated", label: "Not Rated", count: kpiNotRated.length }, // [EDITED: KPI Task - Mahesh Sharma]
              { id: "rated", label: "Rated", count: kpiRated.length } // [EDITED: KPI Task - Mahesh Sharma]
            ]} // [EDITED: KPI Task - Mahesh Sharma]
            activeTab={ratingTab} // [EDITED: KPI Task - Mahesh Sharma]
            onTabChange={setRatingTab} // [EDITED: KPI Task - Mahesh Sharma]
            data={ratingTab === "not_rated" ? kpiNotRated : kpiRated} // [EDITED: KPI Task - Mahesh Sharma]
            loading={ratingLoading} // [EDITED: KPI Task - Mahesh Sharma]
            columns={ // [EDITED: KPI Task - Mahesh Sharma]
              ratingTab === "not_rated" // [EDITED: KPI Task - Mahesh Sharma]
                ? ["Employee Name", "Department", "Manager / Reviewer", "Rating Status"] // [EDITED: KPI Task - Mahesh Sharma]
                : ["Employee Name", "Department", "Self", "TL", "HOD", "Rating Status"] // [EDITED: KPI Task - Mahesh Sharma]
            } // [EDITED: KPI Task - Mahesh Sharma]
            dataKeys={ // [EDITED: KPI Task - Mahesh Sharma]
              ratingTab === "not_rated" // [EDITED: KPI Task - Mahesh Sharma]
                ? ["employee_name", "department_name", "reviewer_name", "rating_status"] // [EDITED: KPI Task - Mahesh Sharma]
                : ["employee_name", "department_name", "selfPoints", "TLPoints", "hod_points", "rating_status"] // [EDITED: KPI Task - Mahesh Sharma]
            } // [EDITED: KPI Task - Mahesh Sharma]
            showExport={false} // [EDITED: KPI Task - Mahesh Sharma]
            onRevokeRating={isAdmin() || isManagement() ? handleRevokeRating : null} // [EDITED: KPI Task - Mahesh Sharma]
          />
        </div>


        <section className="dashboard__announcements" aria-labelledby="dashboard-announcements-title">
          <div className="dashboard__announcements-header">
            <div>
              <p className="dashboard__announcements-eyebrow">Company updates</p>
              <h2 id="dashboard-announcements-title" className="dashboard__announcements-title">
                Announcements
              </h2>
            </div>
            {isAdmin() ? (
              <button
                type="button"
                className="dashboard__announcements-icon"
                onClick={openAnnouncementModal}
                title="Create announcement"
                aria-label="Create announcement"
              >
                <i className="bi bi-megaphone-fill" aria-hidden="true"></i>
              </button>
            ) : (
              <span className="dashboard__announcements-icon" aria-hidden="true">
                <i className="bi bi-megaphone-fill"></i>
              </span>
            )}
          </div>

          <div className="dashboard__cards-section">
          {/* Employee of the Month Card */}
          <div className="dashboard__card">
            <div className="dashboard__card-header">
              <span className="dashboard__card-icon">🏆</span>
              <h3 className="dashboard__card-title">Employee of the Month</h3>
            </div>

            {employeeOfMonth ? (
              <div className="dashboard__card-content">
                <div className="dashboard__employee-avatar">
                  {employeeOfMonth.profile_photo ? (
                    <img
                      src={employeeOfMonth.profile_photo}
                      alt={employeeOfMonth.name}
                      className="dashboard__avatar-img"
                    />
                  ) : (
                    <div className="dashboard__avatar-placeholder">
                      {employeeOfMonth.name?.charAt(0) || "E"}
                    </div>
                  )}
                </div>
                <div className="dashboard__employee-details">
                  <h4 className="dashboard__employee-name">
                    {employeeOfMonth.name}
                  </h4>
                  <p className="dashboard__employee-department">
                    {employeeOfMonth.department}
                  </p>
                </div>
              </div>
            ) : (
              <p className="dashboard__card-empty">
                No employee of the month data
              </p>
            )}
          </div>

          {announcements.length > 0 ? announcements.map((announcement) => (
            <div className="dashboard__card" key={announcement.id}>
              <div className="dashboard__card-header">
                <span className="dashboard__card-icon">🌟</span>
                <h3 className="dashboard__card-title">
                  {getAnnouncementCategoryLabel(announcement.category)}
                </h3>
                {isAdmin() && (
                  <button
                    type="button"
                    className="dashboard-announcement-edit"
                    onClick={() => openAnnouncementModal(announcement)}
                    title="Edit announcement"
                    aria-label={`Edit ${announcement.title || "announcement"}`}
                  >
                    <i className="bi bi-pencil-square" aria-hidden="true"></i>
                  </button>
                )}
              </div>
              <div className="dashboard__announcement-content">
                <div className="dashboard__announcement-person">
                  <div className="dashboard__employee-avatar">
                    {announcement.photo_url ? (
                      <img src={announcement.photo_url} alt="" className="dashboard__avatar-img" />
                    ) : (
                      <div className="dashboard__avatar-placeholder">
                        {(announcement.first_name || announcement.title)?.charAt(0) || "A"}
                      </div>
                    )}
                  </div>
                  <div className="dashboard__employee-details">
                    <h4 className="dashboard__employee-name">
                      {announcement.first_name
                        ? `${announcement.first_name} ${announcement.last_name || ""}`
                        : announcement.title}
                    </h4>
                    {announcement.first_name && (
                      <p className="dashboard__employee-department">
                        {announcement.department_name || ""}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )) : (
            <div className="dashboard__card">
              <div className="dashboard__card-header">
                <span className="dashboard__card-icon">🌟</span>
                <h3 className="dashboard__card-title">Announcements</h3>
              </div>
              <p className="dashboard__card-empty">No announcements published yet</p>
            </div>
          )}

          {/* Upcoming Birthdays Carousel Card */}
          <div className="dashboard__card">
            <div className="dashboard__card-header">
              <span className="dashboard__card-icon">🎂</span>
              <h3 className="dashboard__card-title">Upcoming Birthdays</h3>
            </div>

            {birthdays && birthdays.length > 0 ? (
              <>
                <div className="dashboard__card-content">
                  <div className="dashboard__employee-avatar">
                    {birthdays[birthdayIndex]?.profile_photo ? (
                      <img
                        src={birthdays[birthdayIndex].profile_photo}
                        alt={birthdays[birthdayIndex].name}
                        className="dashboard__avatar-img"
                      />
                    ) : (
                      <div className="dashboard__avatar-placeholder">
                        {birthdays[birthdayIndex]?.name?.charAt(0) || "?"}
                      </div>
                    )}
                  </div>
                  <div className="dashboard__employee-details">
                    <h4 className="dashboard__employee-name">
                      {birthdays[birthdayIndex]?.name}
                    </h4>
                    <p className="dashboard__employee-department">
                      {birthdays[birthdayIndex]?.department}
                    </p>
                    <p className="dashboard__employee-badge">
                      {birthdays[birthdayIndex]?.days_until === 0
                        ? "Today!"
                        : birthdays[birthdayIndex]?.days_until === 1
                          ? "Tomorrow"
                          : `in ${birthdays[birthdayIndex]?.days_until} days`}
                    </p>
                  </div>
                </div>

                {/* Carousel Navigation Dots */}
                {birthdays.length > 1 && (
                  <div className="dashboard__carousel-dots">
                    {birthdays.map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => setBirthdayIndex(idx)}
                        className={`dashboard__carousel-dot ${idx === birthdayIndex ? "dashboard__carousel-dot--active" : ""}`}
                      />
                    ))}
                  </div>
                )}
              </>
            ) : (
              <p className="dashboard__card-empty">No upcoming birthdays</p>
            )}
          </div>

          {/* Work Anniversaries Carousel Card */}
          <div className="dashboard__card">
            <div className="dashboard__card-header">
              <span className="dashboard__card-icon">🎉</span>
              <h3 className="dashboard__card-title">Work Anniversaries</h3>
            </div>

            {workAnniversaries && workAnniversaries.length > 0 ? (
              <>
                <div className="dashboard__card-content">
                  <div className="dashboard__employee-avatar">
                    {workAnniversaries[workAnniversaryIndex]?.profile_photo ? (
                      <img
                        src={
                          workAnniversaries[workAnniversaryIndex].profile_photo
                        }
                        alt={workAnniversaries[workAnniversaryIndex].name}
                        className="dashboard__avatar-img"
                      />
                    ) : (
                      <div className="dashboard__avatar-placeholder">
                        {workAnniversaries[workAnniversaryIndex]?.name?.charAt(
                          0,
                        ) || "?"}
                      </div>
                    )}
                  </div>
                  <div className="dashboard__employee-details">
                    <h4 className="dashboard__employee-name">
                      {workAnniversaries[workAnniversaryIndex]?.name}
                    </h4>
                    <p className="dashboard__employee-department">
                      {workAnniversaries[workAnniversaryIndex]?.department}
                    </p>
                    <div className="dashboard__employee-badge-wrapper">
                      <span className="dashboard__employee-badge">
                        {workAnniversaries[workAnniversaryIndex]?.years}{" "}
                        {workAnniversaries[workAnniversaryIndex]?.years === 1
                          ? "year"
                          : "years"}{" "}
                        with us
                      </span>
                      {workAnniversaries[workAnniversaryIndex]
                        ?.joining_date && (
                        <span className="dashboard__anniversary-date">
                          •{" "}
                          {formatJoiningDate(
                            workAnniversaries[workAnniversaryIndex]
                              .joining_date,
                          )}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Carousel Navigation Dots */}
                {workAnniversaries.length > 1 && (
                  <div className="dashboard__carousel-dots">
                    {workAnniversaries.map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => setWorkAnniversaryIndex(idx)}
                        className={`dashboard__carousel-dot ${idx === workAnniversaryIndex ? "dashboard__carousel-dot--active" : ""}`}
                      />
                    ))}
                  </div>
                )}
              </>
            ) : (
              <p className="dashboard__card-empty">
                No upcoming work anniversaries
              </p>
            )}
          </div>
          </div>
        </section>

        {showAnnouncementModal && (
          <div className="dashboard-modal-overlay" onClick={() => setShowAnnouncementModal(false)}>
            <section className="dashboard-announcement-modal" onClick={(event) => event.stopPropagation()}>
              <div className="dashboard-announcement-modal__header">
                <div>
                  <p className="dashboard__announcements-eyebrow">Company updates</p>
                  <h2>{editingAnnouncementId ? "Edit announcement" : "Create announcement"}</h2>
                </div>
                <button type="button" className="dashboard-modal-close" onClick={() => setShowAnnouncementModal(false)} aria-label="Close announcement form">
                  <i className="bi bi-x-lg" aria-hidden="true"></i>
                </button>
              </div>

              {announcementNotice && <p className="dashboard-announcement-modal__notice">{announcementNotice}</p>}

              <form className="dashboard-announcement-form" onSubmit={handleAnnouncementSubmit}>
                <label>
                  Type
                  <select name="category" value={announcementForm.category} onChange={handleAnnouncementChange}>
                    <option value="employee_of_year">Employee of the Year</option>
                    <option value="employee_of_month">Employee of the Month</option>
                    <option value="recognition">Recognition</option>
                    <option value="general">General update</option>
                  </select>
                </label>
                <label>
                  Title
                  <input name="title" value={announcementForm.title} onChange={handleAnnouncementChange} placeholder="Congratulations, Priya!" required />
                </label>
                <label>
                  Employee (optional)
                  <select name="employee_id" value={announcementForm.employee_id} onChange={handleAnnouncementChange}>
                    <option value="">No employee selected</option>
                    {announcementEmployees.map((employee) => (
                      <option key={employee.employee_id} value={employee.employee_id}>
                        {employee.first_name} {employee.last_name} {employee.department_name ? `(${employee.department_name})` : ""}
                      </option>
                    ))}
                  </select>
                </label>
                <label>
                  Photo (optional)
                  <input type="file" name="announcement_photo" accept="image/jpeg,image/png,image/gif,image/webp" onChange={handleAnnouncementChange} />
                </label>
                <label>
                  Message
                  <textarea name="message" value={announcementForm.message} onChange={handleAnnouncementChange} rows="4" placeholder="Add a short message for the team..." required />
                </label>
                <label>
                  Publish date
                  <input type="date" name="announcement_date" value={announcementForm.announcement_date} onChange={handleAnnouncementChange} required />
                </label>
                <label className="dashboard-announcement-form__checkbox">
                  <input type="checkbox" name="is_active" checked={announcementForm.is_active} onChange={handleAnnouncementChange} />
                  Show on dashboard
                </label>
                <button type="submit" className="dashboard-announcement-form__submit" disabled={announcementSaving}>
                  <i className="bi bi-send-fill" aria-hidden="true"></i>
                  {announcementSaving
                    ? editingAnnouncementId ? "Saving..." : "Publishing..."
                    : editingAnnouncementId ? "Save changes" : "Publish announcement"}
                </button>
              </form>
            </section>
          </div>
        )}

        {/* Employee List Modal - Show Pending KPI Details */}
        {showEmployeeModal && selectedReviewer && (
          <div className="dashboard-modal-overlay" onClick={() => setShowEmployeeModal(false)}>
            <div 
              className="dashboard-modal-content" 
              style={{ maxHeight: '80vh', overflowY: 'auto', width: '90%', maxWidth: '800px', backgroundColor: '#ffffff', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)' }} 
              onClick={(e) => e.stopPropagation()}
            >
              <div className="dashboard-modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #f0f0f0', paddingBottom: '15px', padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px 8px 0 0' }}>
                <h3 style={{ margin: 0, color: '#333', fontSize: '18px', fontWeight: '600' }}>
                  Pending KPI Ratings for <strong style={{ color: '#0066cc' }}>{selectedReviewer.reviewer_name}</strong> ({selectedReviewer.reviewer_role?.toUpperCase()})
                </h3>
                <button className="dashboard-modal-close" onClick={() => setShowEmployeeModal(false)} style={{ fontSize: '24px', border: 'none', background: 'none', cursor: 'pointer', color: '#666' }}>×</button>
              </div>
              <div className="dashboard-modal-body" style={{ padding: '20px', backgroundColor: '#ffffff' }}>
                <div className="employee-list-table">
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#e8f4f8', borderBottom: '2px solid #0066cc' }}>
                        <th style={{ padding: '14px 12px', textAlign: 'left', fontWeight: '700', color: '#0066cc', fontSize: '13px', textTransform: 'uppercase' }}>Employee Name</th>
                        <th style={{ padding: '14px 12px', textAlign: 'left', fontWeight: '700', color: '#0066cc', fontSize: '13px', textTransform: 'uppercase' }}>Role</th>
                        <th style={{ padding: '14px 12px', textAlign: 'left', fontWeight: '700', color: '#0066cc', fontSize: '13px', textTransform: 'uppercase' }}>Department</th>
                        <th style={{ padding: '14px 12px', textAlign: 'left', fontWeight: '700', color: '#0066cc', fontSize: '13px', textTransform: 'uppercase' }}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedReviewer.employees && selectedReviewer.employees.length > 0 ? (
                        selectedReviewer.employees.map((emp, idx) => (
                          <tr key={idx} style={{ borderBottom: '1px solid #eee', backgroundColor: idx % 2 === 0 ? '#ffffff' : '#f9f9f9' }}>
                            <td style={{ padding: '12px', color: '#333' }}>{emp.employee_name}</td>
                            <td style={{ padding: '12px', color: '#555' }}>{emp.employee_role}</td>
                            <td style={{ padding: '12px', color: '#555' }}>{emp.department_name}</td>
                            <td style={{ padding: '12px' }}>
                              <span style={{ 
                                backgroundColor: '#fff3cd', 
                                color: '#856404', 
                                padding: '4px 8px', 
                                borderRadius: '4px',
                                fontSize: '12px',
                                fontWeight: '500'
                              }}>
                                {emp.rating_status}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr style={{ backgroundColor: '#f9f9f9' }}>
                          <td colSpan="4" style={{ textAlign: 'center', padding: '30px 20px', color: '#999', fontSize: '14px', fontStyle: 'italic' }}>
                            No pending ratings
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div style={{ marginTop: '0', padding: '15px 12px', borderTop: '1px solid #eee', backgroundColor: '#f9f9f9', color: '#333', fontSize: '14px', fontWeight: '500' }}>
                    <p style={{ margin: 0 }}>
                      <strong style={{ color: '#0066cc' }}>Total Pending KPIs:</strong> <span style={{ fontSize: '16px', color: '#ff6b6b' }}>{selectedReviewer.pending_count}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </Layout>
  );
};

export default Dashboard;
